import cssGlobal from '../../../utils/cssGlobal';
import constants from '../../../constants/styles';
import 'primereact/components/common/Common.css';
import 'primereact/components/multiselect/MultiSelect.css';
import 'primereact/components/checkbox/Checkbox.css';

const {
  BASE_FONT_FAMILY,
  SELECT_ITEM_HOVER,
  SELECT_BORDER_COLOR,
  HIGHLIGHT_COLOR,
  MULTISELECT_FILTER_BORDER_COLOR
} = constants;

export const styles = {
  multiselect: { width: '100%' }
};

export default cssGlobal({
  '.ui-multiselect': {
    border: `1px solid ${SELECT_BORDER_COLOR}`,
    borderRadius: '4px'
  },
  '.ui-multiselect .ui-multiselect-trigger': {
    border: 'none',
    lineHeight: '40px',
    width: '30px',
    fontSize: '16px',
    color: HIGHLIGHT_COLOR
  },
  '.ui-multiselect .ui-multiselect-label': {
    height: '40px',
    padding: 12,
    paddingRight: 36,
    boxSizing: 'border-box',
    whiteSpace: 'nowrap'
  },
  '.ui-multiselect .ui-multiselect-panel': {
    border: `1px solid ${SELECT_BORDER_COLOR}`,
    background: 'white',
    marginTop: -2,
    borderRadius: '0 0 4px 4px',
    paddingLeft: 0,
    paddingRight: 0
  },
  '.ui-multiselect-panel .ui-multiselect-item .ui-chkbox': {
    border: `2px solid ${SELECT_BORDER_COLOR}`,
    borderRadius: 3
  },
  '.ui-chkbox': {
    marginRight: '0.7em'
  },
  '.ui-chkbox .ui-chkbox-box': {
    width: 10,
    height: 10
  },
  '.ui-multiselect-panel .ui-multiselect-item': {
    paddingTop: 10,
    paddingBottom: 10,
    fontFamily: BASE_FONT_FAMILY
  },
  '.ui-multiselect-item.ui-state-highlight': {
    background: `${SELECT_ITEM_HOVER}`,
    color: 'white'
  },
  '.ui-multiselect-header': {
    background: 'white',
    display: 'flex',
    alignItems: 'center'
  },
  '.ui-multiselect-header .ui-chkbox': {
    border: `2px solid ${SELECT_BORDER_COLOR}`,
    borderRadius: 3
  },
  '.ui-multiselect-filter-container .ui-inputtext': {
    border: 0,
    borderBottom: `1px solid ${MULTISELECT_FILTER_BORDER_COLOR}`,
    padding: '6px 20px 6px 38px',
    height: '30px',
    fontSize: 16
  },
  '.ui-multiselect-header .ui-multiselect-filter-container': {
    flexGrow: 1,
    fontSize: 16
  },
  '.ui-multiselect-header .ui-multiselect-close': {
    flexShrink: 1,
    margin: '0 20px',
    position: 'static'
  },
  '.xfa-check:before': {
    content: '""',
    position: 'absolute',
    display: 'block',
    left: 8,
    top: 13,
    width: 3,
    height: 6,
    borderRight: `solid ${HIGHLIGHT_COLOR}`,
    borderBottom: `solid ${HIGHLIGHT_COLOR}`,
    transform: 'rotate(45deg)'
  },
  '.ui-multiselect-item.ui-state-highlight .fa-check:before': {
    borderRight: `solid white`,
    borderBottom: `solid white`
  }
});



// WEBPACK FOOTER //
// ./src/components/inputs/multiselect/Multiselect.styles.js